export default __webpack_public_path__ + "static/media/telegram-icon.978e2ff2.svg";